import { Flex } from '@chakra-ui/react';
import { IoHome } from 'react-icons/io5';
import React from 'react';

import { BiSolidFoodMenu } from "react-icons/bi";
import { AiFillMessage } from "react-icons/ai";
import { RiCoupon3Fill } from "react-icons/ri";
import { FooterNav } from './FooterNav';

const navItems = [
  { Icon: IoHome, label: "トップ", navigateTo: "/membership/top" },
  { Icon: BiSolidFoodMenu, label: "メニュー", navigateTo: "/membership/menu" },
  { Icon: AiFillMessage, label: "メッセージ", navigateTo: "/membership/messages" },
  { Icon: RiCoupon3Fill, label: "クーポン", navigateTo: "/membership/coupons" },
];

export const MembershipFooter: React.FC = () => {

  return (
    <Flex
      alignItems='center'
      as="footer"
      bgColor='#5371FE'
      bottom='0'
      h='16.3vw'
      justify="space-between"
      p='0 3.72vw'
      position="fixed"
      w='100%'
      zIndex={3}
    >
      {navItems.map((item, index) => (
        <FooterNav key={index} Icon={item.Icon} label={item.label} navigateTo={item.navigateTo} />
      ))}
    </Flex>
  );
};
